import { useEffect, useState, useCallback } from "react";
import { listarCampanhasPorModeloService } from "../../../services/campanhaService";

export function useCampanhas(modeloId?: number) {
  const [campanhas, setCampanhas] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  /**
   * 🔹 Função principal de busca
   * (não precisa receber `id`, ele já vem via closure do modeloId)
   */
  const fetchCampanhas = useCallback(async () => {
    if (!modeloId) return;

    try {
      setLoading(true);
      const data = await listarCampanhasPorModeloService(modeloId);
      setCampanhas(data ?? []);
      setErro(null);
    } catch (err: any) {
      console.error("Erro ao buscar campanhas:", err);
      setErro("Erro ao buscar campanhas.");
    } finally {
      setLoading(false);
    }
  }, [modeloId]);

  /**
   * 🔹 Efeito: busca automática quando o modelo muda
   */
  useEffect(() => {
    if (modeloId) fetchCampanhas();
  }, [modeloId, fetchCampanhas]);

  return { campanhas, loading, erro, fetchCampanhas };
}
